/*
 * Special Campaign 6 — E-Waste Collection & Responsible Disposal.
 *
 * Before SC6_WINDOW (IST) the landing-page highlight and the page
 * (/special-campaign-6) are shown in VIEW-ONLY mode: the form can be seen but
 * not filled, with the SC6_LIVE_CAPTION (DoSEL asked for this on 2026-10-20).
 * On 2026-10-27 the form was opened a day early (from 27 Oct 00:00 IST).
 * Inside the window the form is live. After it, the highlight is gone and the
 * page says the form is closed. The backend accepts uploads only inside the
 * window (SC6_OPEN_FROM / SC6_OPEN_UNTIL in Backend2) — change both together.
 *
 * `?sc6preview=1` on any page makes the form live for that browser tab
 * (sessionStorage), for review before the campaign day. Uploads still follow
 * the server's window.
 */

export const SC6_WINDOW = {
  from: "2026-10-27T00:00:00+05:30",
  until: "2026-11-01T00:00:00+05:30",
};

export const SC6_PATH = "/special-campaign-6";
// Logged-in school: the same form inside the school dashboard (full edit).
export const SC6_SCHOOL_PATH = "/school/special-campaign-6";
// Public E-Waste events (school E-Waste collection reports) — part of Special
// Campaign 6 since 2026-10-27; the old /swachhata-hi-seva/e-waste-events URL
// still works.
export const SC6_EWASTE_EVENTS_PATH = "/special-campaign-6/e-waste-events";
// Special Campaign 6 runs from 16 Sep 2026; THIS is the national event held
// under it on 28 Oct 2026 (the form, the landing highlight and the reports).
export const SC6_CAMPAIGN = "Special Campaign 6";
export const SC6_NAME = "National Event on 28 October 2026";
export const SC6_SHORT = "National Event · 28 Oct 2026";
export const SC6_UNDER = `Under ${SC6_CAMPAIGN}`;
export const SC6_TITLE = "E-Waste Collection & Responsible Disposal";
// Shown on the landing banner and the form page while in view-only mode.
export const SC6_LIVE_CAPTION = "This form will be live on 28.10.2026";

export const SC6_LIMITS = {
  studentsMin: 0,
  studentsMax: 5000,
  itemsMin: 1,
  itemsMax: 1000,
  photosMin: 2,
  photosMax: 3,
  fileMaxMb: 5,
};

// Question text exactly as in the DoSEL format for 28.10.2026 (Q2 added on
// 2026-10-22, so the form has five fields).
export const SC6_QUESTIONS = {
  quizInAssembly: "Quiz on E-Waste organised in morning assembly",
  ewasteItemsCollected: "No. of E-Waste Items Collected",
  disposedToRecycler: "Collected E-Waste disposed of by handing over to authorised recycler/refurbisher",
  studentsParticipated: "No. of Students Participated",
  photos: "Upload geotagged photos (2-3)",
  photosNote: "Ensure the banner displaying “Special Campaign 6” is in the background.",
};

const PREVIEW_KEY = "sc6_preview";

const previewOn = () => {
  try {
    const q = new URLSearchParams(window.location.search).get("sc6preview");
    if (q === "1") window.sessionStorage.setItem(PREVIEW_KEY, "1");
    if (q === "0") window.sessionStorage.removeItem(PREVIEW_KEY);
    return window.sessionStorage.getItem(PREVIEW_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const isSc6Live = (now = Date.now()) => {
  const from = Date.parse(SC6_WINDOW.from);
  const until = Date.parse(SC6_WINDOW.until);
  return (now >= from && now < until) || previewOn();
};

// Preview before the campaign day: uploads are accepted by the server but kept
// apart from the real ones (sc6_school_reports_preview).
export const isSc6Preview = (now = Date.now()) => now < Date.parse(SC6_WINDOW.from) && previewOn();

// Before the campaign day (and not previewing): the form is shown, not filled.
export const isSc6ViewOnly = (now = Date.now()) => now < Date.parse(SC6_WINDOW.from) && !previewOn();

// Landing-page highlight: from now until the campaign day ends.
export const isSc6Shown = (now = Date.now()) => isSc6ViewOnly(now) || isSc6Live(now);
